import script from "./LoginL.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginL.vue?vue&type=script&setup=true&lang=js"

import "./LoginL.vue?vue&type=style&index=0&id=fcf2f120&lang=less"

const __exports__ = script;

export default __exports__